// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2122":"01c553626a9418bb","3397":"8fe34613572bcb74","4023":"bf8d2ae9bb8a44e7","4963":"ff8c90361e861c0b","5640":"7964c5532103b4ec"}[chunkId] + ".css";
};